export default __webpack_public_path__ + "images/avatar_champion.ba62654b.png";